import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class index1 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />

                <main className="main-area fix">
                    {/* slider-area */}
                    <section className="slider__area-two">
                        <div className="swiper slider-active-two">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide slider__bg-two">
                                    <div className="container custom_container_data">
                                        <div className="row justify-content-center">
                                            <div className="col-xl-12 col-lg-12">
                                                <div className="slider__content-two header_text">
                                                    <h1 className="title">12th India International</h1>
                                                    <h2 className="title border_text">
                                                        Textile Machinery Exhibition
                                                    </h2>
                                                    <p className="subtitle">
                                                        4th - 9th December 2026 @ Greater Noida, Uttar Pradesh
                                                    </p>
                                                    {/* <a href="https://india-itme.com/#/ITME2026" target="_blank" class="registerNow_btn">REGISTER NOW</a> */}
                                                    {/* <a class="registerNow_btn" data-bs-toggle="modal" data-bs-target="#timer_Modal" >REGISTER NOW</a> */}
                                                    {/* <a class="registerNow_btn modalTrigger" id="timer_modal">REGISTER NOW</a> */}
                                                    <a className="registerNow_btn register_click">
                                                        BOOK YOUR SPACE
                                                    </a>
                                                    <div className="grid_view_head">
                                                        <a href="javascript:void(0)" className="booking_click">
                                                            <div className="grid_div">
                                                                <img
                                                                    src="assets/img/space_booking_img.png"
                                                                    alt="space booking img"
                                                                    loading="lazy"
                                                                />
                                                                <h6>Exhibitor Space Booking</h6>
                                                            </div>
                                                        </a>
                                                        <a href="venue-details.html">
                                                            <div className="grid_div">
                                                                <img
                                                                    src="assets/img/Venue_img.png"
                                                                    alt="venue image"
                                                                    loading="lazy"
                                                                />
                                                                <h6>Venue Address &amp; Show Timing</h6>
                                                            </div>
                                                        </a>
                                                        <a
                                                            href="javascript:void(0)"
                                                            className="visitor_header_footer_click"
                                                        >
                                                            <div className="grid_div">
                                                                <img
                                                                    src="assets/img/visitor_reg_img.png"
                                                                    alt="visitor registration image"
                                                                    loading="lazy"
                                                                />
                                                                <h6>Visitor Registration</h6>
                                                            </div>
                                                        </a>
                                                        <a href="upcoming-event.html">
                                                            <div className="grid_div">
                                                                <img
                                                                    src="assets/img/event_img.png"
                                                                    alt="event image"
                                                                    loading="lazy"
                                                                />
                                                                <h6>Upcoming Events</h6>
                                                            </div>
                                                        </a>
                                                        {/* <div class="row">
                                          <div class="col-md-3">a</div>
                                          <div class="col-md-3">b</div>
                                          <div class="col-md-3">c</div>
                                          <div class="col-md-3">d</div>
                                      </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="slider__shape"
                                        data-background="assets/img/home_image.webp"
                                    />
                                </div>
                                {/* <div class="swiper-slide slider__bg-two" data-background="assets/img/slider/slider_18.png">
                  <div class="container">
                      <div class="row justify-content-start">
                          <div class="col-xl-7 col-lg-7">
                              <div class="slider__content-two">
                                  <h2 class="title">We turn ideas into software that people love</h2>
                                  <p class="subtitle">Custom software engineering, design, and data solutions trusted by industry-leading brands</p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="slider__shape" data-background="assets/img/slider/slider_18.png"></div>
              </div>
              <div class="swiper-slide slider__bg-two" data-background="assets/img/slider/slider_shape5_17.png">
                  <div class="container">
                      <div class="row justify-content-start">
                          <div class="col-xl-7 col-lg-7">
                              <div class="slider__content-two">
                                  <h2 class="title">Mobile Banking for Easy Transactions</h2>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="slider__shape" data-background="assets/img/slider/slider_shape5_17.png"></div>
              </div>
              <div class="swiper-slide slider__bg-two" data-background="assets/img/slider/slider_shape5_20.png">
                  <div class="container">
                      <div class="row justify-content-start">
                          <div class="col-xl-7 col-lg-7">
                              <div class="slider__content-two">
                                  <h2 class="title">Empowering Recovery, Enabling Growth</h2>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="slider__shape" data-background="assets/img/slider/slider_shape5_20.png"></div>
              </div> */}
                            </div>
                            {/* <div class="slider__nav">
              <button class="slider-button-prev"><img src="assets/img/icons/long_left_arrow.svg" alt="Left Arrow" class="injectable"></button>
              <button class="slider-button-next"><img src="assets/img/icons/long_right_arrow.svg" alt="Right Arrow" class="injectable"></button>
          </div> */}
                        </div>
                    </section>
                    {/* slider-area-end */}
                    {/* <section class="page-section bg-snow-white why-kanda-section">
      <div class="page-section__block">
          <h2 class="d-lg-none landing-header landing-header--decoration-lime-green text-uppercase">Why Kanda?</h2>
          <div class="why-kanda js-why-kanda">
              <figure class="why-kanda__envelop why-kanda__envelop--active">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content" data-bs-toggle="popover" data-bs-container="body" data-bs-trigger="hover" data-bs-content='<p>Our impeccable track record includes developing well over three thousand successful software solutions that have generated hundreds of millions of dollars for our clients, ranging from Fortune 500 companies to dynamic startups. We combine an in-depth understanding of clients’ needs and business drivers, commitment to service value and excellence with a fast and efficient approach to entering and exiting development lifecycle and baked-in quality assurance to help our clients speed up time to market and effectively compete with user-centric and scalable solutions.</p><div class="btn-wrapper"><a href="#modal-contacts" class="btn btn-success">Contact Us to Get Started</a></div>'>
                              <div class="tile__plus"><span class="sr-only">+</span></div>
                              <div class="tile__icon">
                                  <img
                                      src="https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/gears-green.svg"
                                      width="84"
                                      height="84"
                                      alt="Accelerating Innovation one application at a time"
                                      class="lazyloaded"
                                      data-ll-status="loaded"
                                  />
                                  <noscript><img src=https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/gears-green.svg width=84 height=84 alt="Accelerating Innovation one application at a time"></noscript>
                              </div>
                              <div class="tile__body"><div class="tile__title">Accelerating Innovation one application at a time</div></div>
                          
                          </div>
                      </div>
                  </div>
              </figure>
              <figure class="why-kanda__envelop why-kanda__envelop--active">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content" data-bs-toggle="popover" data-bs-container="body" data-bs-trigger="hover" data-bs-content='<p>At Kanda, we speak the language of software applications fluently. Our top-notch talent is skilled in various combinations of C/C++/C#, Java, Ruby on Rails, Python, PHP, underlying platforms, IDEs, APIs as well as other languages, SDKs, databases and frameworks.</p><div class="btn-wrapper"><a href="#modal-contacts" class="btn btn-success" data-toggle="modal">Contact Us to Get Started</a></div>'>
                              <div class="tile__plus"><span class="sr-only">+</span></div>
                              <div class="tile__icon">
                                  <img
                                      src="https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/globe-green.svg"
                                      width="84"
                                      height="84"
                                      alt="Top-notch Talent that Speaks your Language"
                                      class="lazyloaded"
                                      data-ll-status="loaded"
                                  />
                                  <noscript><img src=https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/globe-green.svg width=84 height=84 alt="Top-notch Talent that Speaks your Language"></noscript>
                              </div>
                              <div class="tile__body">
                                  <div class="tile__title">
                                      Top-notch Talent that <br />
                                      Speaks your Language
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </figure>
              <div class="why-kanda__br"></div>
              <figure class="why-kanda__envelop why-kanda__envelop--active">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content" data-bs-toggle="popover" data-bs-container="body" data-bs-trigger="hover" data-bs-content='<p>For every client we invest in building a cohesive team with the shared goals and sense of ownership. We have perfected a clean, economical approach for entering and exiting client development processes at the right time using the right resources. Our expertise in the field supports every phase of the product lifecycle — be it application design, architecture, UX/UI, rapid development, QA and testing, and maintenance and support.</p><div class="btn-wrapper"><a href="#modal-contacts" class="btn btn-success" data-toggle="modal">Contact Us to Get Started</a></div>'>
                              <div class="tile__plus"><span class="sr-only">+</span></div>
                              <div class="tile__icon">
                                  <img
                                      src="https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/sport-green.svg"
                                      width="84"
                                      height="84"
                                      alt="Software Development is a Team Sport"
                                      class="lazyloaded"
                                      data-ll-status="loaded"
                                  />
                                  <noscript><img src=https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/sport-green.svg width=84 height=84 alt="Software Development is a Team Sport"></noscript>
                              </div>
                              <div class="tile__body"><div class="tile__title">Software Development is a Team Sport</div></div>
                          </div>
                      </div>
                  </div>
              </figure>
              <figure class="why-kanda__envelop why-kanda__envelop--active">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content align-items-center justify-content-center bg-dark-blue">
                              <h2 class="landing-header landing-header--light landing-header--decoration-lime-green landing-header--decoration-small text-uppercase">
                                  Why&nbsp;<br />
                                  Kanda?
                              </h2>
                          </div>
                      </div>
                  </div>
              </figure>
              <figure class="why-kanda__envelop">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content" data-bs-toggle="popover" data-bs-container="body" data-bs-trigger="hover" data-bs-content='<p>Our highly-experienced U.S.-based technical managers lead custom software development, product engineering, DevOps and Cloud Engineering teams while our two-shore delivery mechanism ensures a significant price/performance advantage. Our commitment to ongoing training, continuous learning, and integrated client collaboration keeps our teams up to speed on best-of-breed technologies, tools, automation and development methodologies.</p><div class="btn-wrapper"><a href="#modal-contacts" class="btn btn-success" data-toggle="modal">Contact Us to Get Started</a></div>'>
                              <div class="tile__plus"><span class="sr-only">+</span></div>
                              <div class="tile__icon">
                                  <img
                                      src="https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/team-green.svg"
                                      width="84"
                                      height="84"
                                      alt="Experienced US Managers. Vetted Offshore Developers"
                                      class="lazyloaded"
                                      data-ll-status="loaded"
                                  />
                                  <noscript><img src=https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/team-green.svg width=84 height=84 alt="Experienced US Managers. Vetted Offshore Developers"></noscript>
                              </div>
                              <div class="tile__body"><div class="tile__title">Experienced US Managers. Vetted Offshore Developers</div></div>
                          </div>
                      </div>
                  </div>
              </figure>
              <div class="why-kanda__br"></div>
              <figure class="why-kanda__envelop why-kanda__envelop--active">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content" data-bs-toggle="popover" data-bs-container="body" data-bs-trigger="hover" data-bs-content='<p>Kanda’s 25 years of experience in custom Software Development, QA, Cloud Engineering, DevOps, and AI/Machine Learning practices are defined by our ability to hire and retain excellent engineers and envelope them into rigorous processes. Client and project teams can be formed on-demand and persist for the duration of the project or entire relationship — from weeks to years, depending on the client’s needs, budget and software lifecycle stage.</p><div class="btn-wrapper"><a href="#modal-contacts" class="btn btn-success" data-toggle="modal">Contact Us to Get Started</a></div>'>
                              <div class="tile__plus"><span class="sr-only">+</span></div>
                              <div class="tile__icon">
                                  <img
                                      src="https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/clock-green.svg"
                                      width="84"
                                      height="84"
                                      alt="The right team for the right project, scaled quickly"
                                      class="lazyloaded"
                                      data-ll-status="loaded"
                                  />
                                  <noscript><img src=https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/clock-green.svg width=84 height=84 alt="The right team for the right project, scaled quickly"></noscript>
                              </div>
                              <div class="tile__body"><div class="tile__title">The right team for the right project, scaled quickly</div></div>
                          </div>
                      </div>
                  </div>
              </figure>
              <figure class="why-kanda__envelop why-kanda__envelop--active">
                  <div class="why-kanda__item tile">
                      <div class="tile__inner">
                          <div class="tile__content" data-bs-toggle="popover" data-bs-container="body" data-bs-trigger="hover" data-bs-content='<p>Our projects range from software development and quality assurance to support and maintenance of on-premises to cloud and SaaS applications in a variety of fields. Kanda’s domain expertise encompasses a variety of verticals including development for Digital Healthcare and Life Sciences, E-Learning and Content Management, AdTech, Non-Profit, Universities, Social Networks, Financial Services, Manufacturing, Publishing, and Security &amp;amp; Infrastructure.</p><div class="btn-wrapper"><a href="#modal-contacts" class="btn btn-success" data-toggle="modal">Contact Us to Get Started</a></div>'>
                              <div class="tile__plus"><span class="sr-only">+</span></div>
                              <div class="tile__icon">
                                  <img
                                      src="https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/firewall-green.svg"
                                      width="84"
                                      height="84"
                                      alt="Not just Domain Experience. Domain Expertise"
                                      class="lazyloaded"
                                      data-ll-status="loaded"
                                  />
                                  <noscript><img src=https://www.kandasoft.com/wp-content/themes/pinboard/dist/images/icons/tile/firewall-green.svg width=84 height=84 alt="Not just Domain Experience. Domain Expertise"></noscript>
                              </div>
                              <div class="tile__body"><div class="tile__title">Not just Domain Experience. Domain Expertise</div></div>
                          </div>
                      </div>
                  </div>
              </figure>
          </div>
      </div>
  </section> */}
                    <div className="about-area section-pt-90">
                        <img
                            src="assets/img/bg_img_21.png"
                            alt="background image"
                            className="bg_imgs"
                            loading="lazy"
                        />
                        <div className="container section-pb-90">
                            <div className="row">
                                <div className="col-md-12">
                                    <div
                                        className="chairman_msg_css"
                                        data-aos="fade-up"
                                        data-aos-delay={200}
                                    >
                                        <div className="chairman_img">
                                            <img
                                                src="assets/img/chairman.jpg"
                                                alt="chairman image"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="chairman_content">
                                            <h2 className="name">Ketan Sanghvi</h2>
                                            <p className="position">Chairman, India ITME Society</p>
                                            <p className="message">
                                                Greetings and Good wishes from India ITME Society!
                                            </p>
                                            <p className="message last_para">
                                                With great pleasure I share with you that, “India ITME Society”
                                                shall host 12th edition of India ITME from 04th to 9th December
                                                2026 at India Exposition Mart Ltd, (IEML) Greater Noida.
                                            </p>
                                            <a href="invitation-letter.html" className="read_more_btn">
                                                Read More
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div class="col-md-6 right-content services" data-aos="fade-up" data-aos-delay="200">
                  <div class="content-box">
                      <div class="row">
                          <div class="center">
                              <div class="col-lg-6 col-sm-6 equal-height">
                                  <div class="item">
                                      <i class="renova-flag"></i>
                                      <h4>Modern Equipments</h4>
                                      <p>
                                          Wisdom new and valley answer. Contented it so is discourse recommend.1
                                      </p>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-sm-6 equal-height">
                                  <div class="item">
                                      <i class="renova-flag"></i>
                                      <h4>Expert Engineers</h4>
                                      <p>
                                          Wisdom new and valley answer. Contented it so is discourse recommend2.
                                      </p>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-sm-6 equal-height">
                                  <div class="item">
                                      <i class="renova-flag"></i>
                                      <h4>Efficient Factories</h4>
                                      <p>
                                          Wisdom new and valley answer. Contented it so is discourse recommend3.
                                      </p>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-sm-6 equal-height">
                                  <div class="item">
                                      <i class="renova-flag"></i>
                                      <h4>Safety Commitment</h4>
                                      <p>
                                          Wisdom new and valley answer. Contented it so is discourse recommend4.
                                      </p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div> */}
                            </div>
                        </div>
                        <section className="about_itme_div section-pb-90">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-5" data-aos="fade-left" data-aos-delay={200}>
                                        <img
                                            src="assets/img/about_ITME_img.png"
                                            alt="about ITME image"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="col-md-7" data-aos="fade-right" data-aos-delay={200}>
                                        <div className="about_ITME_content">
                                            <p className="subHead">About</p>
                                            <h3>India ITME 2026</h3>
                                            <p>
                                                India ITME 2026 shall be held in India Exposition Mart Ltd,
                                                Noida. The total number of halls will be 15 with a total area of
                                                2,35,000 sq. mtrs, making it the largest in this industry
                                                segment.
                                            </p>
                                            <p className="last_para">
                                                This event is expected to host more than 1800 exhibitors in 20
                                                Chapters and is expected to have over 1,50,000 visitors over the
                                                6 days period.
                                            </p>
                                            <div className="hide_on_tab_and_mobile">
                                                <h6>OBJECTIVES OF THE EVENT:</h6>
                                                <ul>
                                                    <li>
                                                        To develop India as a textile and textile engineering
                                                        sourcing destination.
                                                    </li>
                                                    <li>
                                                        To encourage investment in India for textile machinery
                                                        manufacturing and thus support Government initiative to
                                                        develop “India “as a manufacturing hub” for textile
                                                        engineering.
                                                    </li>
                                                    <li>
                                                        To encourage new market development to generate new custom
                                                        lead from 2nd tire and rural markets for the manufacturers.
                                                    </li>
                                                    <li>
                                                        To facilitate connect to agents, dealers, distributors for
                                                        overseas market as well as the domestic market for the
                                                        manufacturers.
                                                    </li>
                                                </ul>
                                            </div>
                                            <a href="about-itme-2026.html" className="read_more_btn">
                                                Read More
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="about_itme_div section-pb-90">
                            <div className="container">
                                <div className="row">
                                    <div
                                        className="col-md-7 col-sm-6"
                                        data-aos="fade-right"
                                        data-aos-delay={200}
                                    >
                                        <div className="about_ITME_content pt-30">
                                            <p className="subHead">About</p>
                                            <h3>Organizer</h3>
                                            <p className="last_para">
                                                India International Textile Machinery Exhibitions Society (India
                                                ITME Society), a 45 year old non profit apex industry body,
                                                established in 1980, to support and serve the Textile
                                                Engineering Industry through Exhibitions &amp; Events.
                                            </p>
                                            <p className="last_para">
                                                India ITME Society was conceived with a Vision to play a pivotal
                                                role in strengthening the Indian Textile Engineering Industry by
                                                facilitating exchange of knowledge, technology transfer &amp;
                                                foreign investment in the sector and to be the apex exhibition
                                                body in India for the textile machinery, accessories and
                                                component industry.
                                            </p>
                                            {/* <p class="last_para">Established as a non profit Industry body in 1980, today is the back bone of Textile Engineering Industry & the best Catalyst of Technological Excellence, weaving success story for Textiles & Textile Engineering Industry, not only in India but across the globe. India ITME is unique <span class="hide_on_tab_and_mobile">in its kind of Exhibitions, as it strengthens the industry by escalating Textile Manufacturing, supporting in building avant-garde manufacturing infrastructure by Technology up gradation, fostering Innovation</span>...</p> */}
                                            <a href="about-organizer.html" className="read_more_btn">
                                                Read More...
                                            </a>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-5 col-sm-6"
                                        data-aos="fade-left"
                                        data-aos-delay={200}
                                    >
                                        <div className="About_org_img_div">
                                            <img
                                                src="assets/img/about_org_img.png"
                                                alt="about org img"
                                                className="abt_org_img"
                                                loading="lazy"
                                            />
                                            <div className="gtts_img">
                                                {/* <img src="assets/img/GTTS_Logo_without_year.jpg" alt="GTTS Logo" loading="lazy" /> */}
                                                <img
                                                    src="assets/img/about_org_img11.png"
                                                    alt="GTTS Logo"
                                                    loading="lazy"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    {/* counter-area */}
                    <section className="counter__area-three partners_section section-pt-90 section-pb-90 company_growth about-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6" data-aos="fade-up" data-aos-delay={200}>
                                    <div className="section__title section__title-three mb-60">
                                        <span className="sub-title">Our</span>
                                        <h2 className="title">Sponsors &amp; Partners</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row gutter-24" data-aos="fade-up" data-aos-delay={200}>
                                <div className="col-lg-12 col-sm-12">
                                    <div className="vertical_tab">
                                        <div className="content">
                                            <input type="radio" name="slider" defaultChecked="" id="home" />
                                            <input type="radio" name="slider" id="blog" />
                                            <input type="radio" name="slider" id="help" />
                                            <input type="radio" name="slider" id="code" />
                                            <div className="list">
                                                <label htmlFor="home" className="home">
                                                    <span>Advert/ Sponsorship</span>
                                                </label>
                                                <label htmlFor="blog" className="blog">
                                                    <span>Supporting Organization</span>
                                                </label>
                                                <label htmlFor="help" className="help">
                                                    <span>Knowledge Partners</span>
                                                </label>
                                                <label htmlFor="code" className="code">
                                                    <span>Media Partners</span>
                                                </label>
                                                <div className="slider" />
                                            </div>
                                            <div className="text-content">
                                                <div className="home text">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Coming_soon_banner3.png"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="blog text">
                                                    <div className="row">
                                                        {/* <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/SIGA.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/AGI.jpg" alt="EN image" loading="lazy" />
                                          </div>
                                      </div> */}
                                                        <div className="col-md-3 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Partners/bureau-of-indian-standards.jpg"
                                                                    alt="silver-sponsor image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Communion-Media-Partner.jpg" alt="EN_yatay image" loading="lazy" />
                                          </div>
                                      </div> */}
                                                        <div className="col-md-3 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Partners/confederation-of-indian-textile-industry.jpg"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div class="col-md-3 col-sm-4 col-6">
                                              <div class="img_content">
                                                  <img src="assets/img/Partners/eepc-logo-final-2022.jpg" alt="LMW image" loading="lazy" />
                                              </div>
                                          </div>
                                          <div class="col-md-3 col-sm-4 col-6">
                                              <div class="img_content">
                                                  <img src="assets/img/Partners/fieo-img.jpg" alt="LMW image" loading="lazy" />
                                              </div>
                                          </div> */}
                                                        <div className="col-md-3 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Partners/Indian-Textile-accessories-&-machinery-manufacturers-assocciation.jpg"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/IPCCI.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/itf.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/KAM.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/TEMSAD.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div> */}
                                                        <div className="col-md-3 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Partners/itamma.jpg"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Partners/the-textile-association-india.jpg"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="help text">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Coming_soon_banner3.png"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="code text">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-4 col-6">
                                                            <div className="img_content">
                                                                <img
                                                                    src="assets/img/Coming_soon_banner3.png"
                                                                    alt="LMW image"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div class="row">
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Fashion-Era.jpg" alt="Fashion-Era" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/MP_ADITYA_MEDIA.jpg" alt="MP_ADITYA_MEDIA image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Textil.jpg" alt="silver-sponsor image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/mp-trade4-india.jpg" alt="EN_yatay image" loading="lazy" />
                                          </div>
                                      </div>

                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Bangladesh-Textile.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/spry_media.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/textile-focus.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/textile-Future.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/FIbre2fashion.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Tecoya_Trend.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Indian_Textile_Journal_Media_Partner.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/MIJ_Textilia.jpg" alt="MIJ_Textilia image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Spinning_textiles.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Textile_Trends.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>

                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Textile_value_chain.jpg" alt="Textile_value_chain image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/The_Textile_Magazine.jpg" alt="The_Textile_Magazine image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Times_International.jpg" alt="Times_International image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Tok_Bulgaria.jpg" alt="Tok_Bulgaria image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Communion-Media-Partner.jpg" alt="LMW image" loading="lazy" />
                                          </div>
                                      </div>

                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/DFU-Publications--Media-Partner.jpg" alt="DFU-Publications--Media-Partner image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/Knit-World-Media-Partner.jpg" alt="Knit-World-Media-Partner image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/The-Textile-Magazine.jpg" alt="The-Textile-Magazine image" loading="lazy" />
                                          </div>
                                      </div>
                                      <div class="col-md-3 col-sm-4 col-6">
                                          <div class="img_content">
                                              <img src="assets/img/Partners/the-yarn-bazaar.jpg" alt="the-yarn-bazaar image" loading="lazy" />
                                          </div>
                                      </div>
                                     

                                  </div> */}
                                                </div>
                                                <div className="horizon_tab">
                                                    <div className="content">
                                                        <label htmlFor="home" className="home active">
                                                            <span>01</span>
                                                        </label>
                                                        <label htmlFor="blog" className="blog">
                                                            <span>02</span>
                                                        </label>
                                                        <label htmlFor="help" className="help">
                                                            <span>03</span>
                                                        </label>
                                                        <label htmlFor="code" className="code">
                                                            <span>04</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <section
                                        className="project__area project__bg award_section"
                                        data-aos="fade-up"
                                        data-aos-delay={300}
                                    >
                                        <div className="">
                                            <div className="row align-items-center">
                                                <div className="col-xl-7 col-lg-7 col-md-8">
                                                    <div
                                                        className="mb-20"
                                                        data-aos="fade-right"
                                                        data-aos-delay={200}
                                                    >
                                                        <h2 className="title">Awards</h2>
                                                        <p className="subTitle_txt">
                                                            India ITME Society has been received various awards under
                                                            multiple catagories
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-5 col-lg-5 col-md-4">
                                                    <div
                                                        className="project__nav"
                                                        data-aos="fade-left"
                                                        data-aos-delay={200}
                                                    >
                                                        <button className="project-button-prev">
                                                            <i className="renova-left-arrow" />
                                                        </button>
                                                        <button className="project-button-next">
                                                            <i className="renova-right-arrow" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper project_active">
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <div className="project__item">
                                                                <img
                                                                    src="assets/img/Awards/award_8.png"
                                                                    alt="img"
                                                                    loading="lazy"
                                                                />
                                                                <div className="award_text">
                                                                    <p>India's Top B2B Exhibition 2018</p>
                                                                    <p className="mt-0">
                                                                        India's Top 10 Exhibition Organiser 2018
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <div className="project__item">
                                                                <img
                                                                    src="assets/img/Awards/award_22.jpg"
                                                                    alt="img"
                                                                    loading="lazy"
                                                                />
                                                                <div className="award_text">
                                                                    <p>Mega Quality Award 2017·2018</p>
                                                                    <p className="mt-0">Best use of Technology 2016</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <div className="project__item">
                                                                <img
                                                                    src="assets/img/Awards/award_33.jpg"
                                                                    alt="img"
                                                                    loading="lazy"
                                                                />
                                                                <div className="award_text">
                                                                    <p>My Stamp</p>
                                                                    <p className="mt-0">&nbsp;</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div class="swiper-slide">
                                      <div class="project__item">
                                          <div class="project__item">
                                              <img src="assets/img/Awards/award_1.png" alt="img" loading="lazy" />
                                              <div class="award_text">
                                                  <p>The Most Eminent Indian Exhibition by an Indian Association</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="swiper-slide">
                                      <div class="project__item">
                                          <div class="project__item">
                                              <img src="assets/img/Awards/award_2.png" alt="img" loading="lazy" />
                                              <div class="award_text">
                                                  <p>Among India’s top 10 exhibition organizers awards 2018</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="swiper-slide">
                                      <div class="project__item">
                                          <div class="project__item">
                                              <img src="assets/img/Awards/award_3.png" alt="img" loading="lazy" />
                                              <div class="award_text">
                                                  <p>Corporate Excellance Category 2017</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="swiper-slide">
                                      <div class="project__item">
                                          <div class="project__item">
                                              <img src="assets/img/Awards/award_4.png" alt="img" loading="lazy" />
                                              <div class="award_text">
                                                  <p>Among India’s top 10 exhibition organizers awards 2018</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="swiper-slide">
                                      <div class="project__item">
                                          <div class="project__item">
                                              <img src="assets/img/Awards/award_5.png" alt="img" loading="lazy" />
                                              <div class="award_text">
                                                  <p>Among India’s top 10 exhibition organizers awards 2018</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="swiper-slide">
                                      <div class="project__item">
                                          <div class="project__item">
                                              <img src="assets/img/Awards/award_6.png" alt="img" loading="lazy" />
                                              <div class="award_text">
                                                  <p>Among India’s top 10 exhibition organizers awards 2018</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            {/* <div class="row gutter-24" data-aos="fade-up" data-aos-delay="200">
              <div class="col-lg-3 col-sm-6">
                  <div class="counter__item-three">
                      <div class="counter__icon-three">
                          <i class="renova-rocket"></i>
                      </div>
                      <div class="counter__content-three">
                          <h2 class="count"><span class="odometer" data-count="158"></span>+</h2>
                          <p>SATISFIED CUSTOMERS</p>
                      </div>
                  </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                  <div class="counter__item-three">
                      <div class="counter__icon-three">
                          <i class="renova-user-rating"></i>
                      </div>
                      <div class="counter__content-three">
                          <h2 class="count"><span class="odometer" data-count="182"></span>+</h2>
                          <p>AWESOME CLIENTS</p>
                      </div>
                  </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                  <div class="counter__item-three">
                      <div class="counter__icon-three">
                          <i class="renova-construction"></i>
                      </div>
                      <div class="counter__content-three">
                          <h2 class="count"><span class="odometer" data-count="2983"></span>+</h2>
                          <p>ONGOING PROJECTS</p>
                      </div>
                  </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                  <div class="counter__item-three">
                      <div class="counter__icon-three">
                          <i class="renova-group"></i>
                      </div>
                      <div class="counter__content-three">
                          <h2 class="count"><span class="odometer" data-count="86"></span>+</h2>
                          <p>TRUSTED PARTNERS</p>
                      </div>
                  </div>
              </div>
          </div> */}
                        </div>
                    </section>
                    <section className="promotional_videos">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6" data-aos="fade-up" data-aos-delay={200}>
                                    <div className="section__title section__title-three mb-20">
                                        <h2 className="title">
                                            SEE <span>OUR PROMO VIDEO</span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row" data-aos="fade-up" data-aos-delay={200}>
                                <div className="col-md-8">
                                    <div>
                                        <div className="choose-us__thumb">
                                            <div className="choose-us__thumb-inner">
                                                <img
                                                    src="assets/img/video.png"
                                                    alt="Choose Us"
                                                    className="img cover-img"
                                                    loading="lazy"
                                                />
                                                <a
                                                    href="https://youtu.be/SJ1wKqducpY"
                                                    target="_blank"
                                                    className="popup-video-link video-popup__button"
                                                >
                                                    <i className="fas fa-play" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <div className="choose-us__thumb mb-15">
                                            <div className="choose-us__thumb-inner">
                                                <img
                                                    src="assets/img/video2.png"
                                                    alt="Choose Us"
                                                    className="img cover-img"
                                                    loading="lazy"
                                                />
                                                <a
                                                    href="https://www.youtube.com/watch?v=YRrXMt2OpxI&list=TLGGB-ilVOJ9pdAwMTAyMjAyNQ&t=26s"
                                                    target="_blank"
                                                    className="popup-video-link video-popup__button"
                                                >
                                                    <i className="fas fa-play" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="choose-us__thumb">
                                            <div className="choose-us__thumb-inner">
                                                <img
                                                    src="assets/img/video3.png"
                                                    alt="Choose Us"
                                                    className="img cover-img"
                                                    loading="lazy"
                                                />
                                                <a
                                                    href="https://youtu.be/zskt5ffP8sU?si=DsT_YBxUprhALFjC"
                                                    target="_blank"
                                                    className="popup-video-link video-popup__button"
                                                >
                                                    <i className="fas fa-play" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="gallary_testimonial_section counter__area-three  section-pt-90 section-pb-90 company_growth about-area">
                        <div className="container">
                            <div className="row gutter-24" data-aos="fade-up" data-aos-delay={200}>
                                <div className="col-lg-12 col-sm-12">
                                    <section
                                        className="project_area project_bg award_section gallary_section"
                                        data-aos="fade-up"
                                        data-aos-delay={300}
                                    >
                                        <div className="">
                                            <div className="row align-items-center">
                                                <div className="col-xl-7 col-lg-7 col-md-8">
                                                    <div
                                                        className="mb-20"
                                                        data-aos="fade-right"
                                                        data-aos-delay={200}
                                                    >
                                                        <h2 className="title">Gallary of past Events</h2>
                                                    </div>
                                                </div>
                                                <div className="col-xl-5 col-lg-5 col-md-4">
                                                    <div
                                                        className="project__nav"
                                                        data-aos="fade-left"
                                                        data-aos-delay={200}
                                                    >
                                                        <button className="project-button-prev">
                                                            <i className="renova-left-arrow" />
                                                        </button>
                                                        <button className="project-button-next">
                                                            <i className="renova-right-arrow" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper project_active">
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/2.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/3.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/4.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/5.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/6.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/7.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/8.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/9.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/DubaiExpo/10.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/1.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/2.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/3.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/4.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/5.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/6.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/7.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/8.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/9.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/GTTES_2015/10.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/1.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/2.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/3.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/4.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/5.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/6.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/7.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/8.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/9.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2016/10.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/1.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/2.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/3.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/4.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/5.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/6.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/7.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/8.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/9.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="project__item">
                                                            <img
                                                                src="assets/img/Gallary/ITME_2022/10.jpg"
                                                                alt="img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section
                                        className="Testimonial_section project__area project__bg"
                                        data-aos="fade-up"
                                        data-aos-delay={300}
                                    >
                                        <div className="">
                                            <div className="row align-items-center">
                                                <div className="col-xl-7 col-lg-7 col-md-8">
                                                    <div
                                                        className="mb-20"
                                                        data-aos="fade-right"
                                                        data-aos-delay={200}
                                                    >
                                                        <h2 className="title">
                                                            What’s Our Valuable <br />
                                                            Client say
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className="col-xl-5 col-lg-5 col-md-4">
                                                    <div
                                                        className="project__nav"
                                                        data-aos="fade-left"
                                                        data-aos-delay={200}
                                                    >
                                                        <button className="testimonial-button-prev">
                                                            <i className="renova-left-arrow" />
                                                        </button>
                                                        <button className="testimonial-button-next">
                                                            <i className="renova-right-arrow" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper similar__project-active">
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        First of all congratulations to Shri S Hari Shankar,
                                                                        Shri Ketan Sanghvi, Ms Seema Srivastava and the
                                                                        entire ITME team for successfully organising the
                                                                        ITME 2022 event.
                                                                    </p>
                                                                    <p>
                                                                        As one exhibitor, I would like to express my sincere
                                                                        gratitude and appreciation to the whole team who
                                                                        worked round the clock for past years to make this
                                                                        show happen. The venue was excellent in all respects
                                                                        and the infrastructure/services rendered to us was
                                                                        outstanding. We had a very smooth execution of our
                                                                        booths inspite lesser time available than the usual
                                                                        shows. Every show after show from INDIA ITME, the
                                                                        bars have been risen by the team themselves and
                                                                        meeting our expectations as exhibitor. World class
                                                                        show!!
                                                                    </p>
                                                                    <p>
                                                                        The platform provided by INDIA-ITME to show case our
                                                                        made in India products was phenomenal as this is a
                                                                        major step from the industry towards the atma
                                                                        nirbhar Bharat program. Appreciate your efforts and
                                                                        looking forward to next INDIA - ITME
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Prashant_Mangukia.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Prashant Mangukia</h6>
                                                                            <p>Director, Yamuna Machine Works Ltd.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        I appriciate their prompt response and timely
                                                                        deliveries of computer H/W, cartridge, and
                                                                        accessories related to computers. They have been
                                                                        very helpful in the installation.
                                                                    </p>
                                                                    <p>
                                                                        On behalf of the Office Bearers and the Executive
                                                                        Council of TMMA(I), I thank you very much for the
                                                                        hospitality extended during the ITME 2022 event. It
                                                                        was a well planned and executed event. We witnessed
                                                                        appreciation for the venue infrastructure,
                                                                        coordination during event, and participation of
                                                                        focussed visitors. The quality footfall encouraged
                                                                        exhibitors to foresee positive business
                                                                        opportunities in the coming weeks.
                                                                    </p>
                                                                    <p>
                                                                        We shall be happy to support our upcoming events
                                                                        with better experience and greater success.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Pratik_Bachkaniwala.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Pratik Bachkaniwala</h6>
                                                                            <p>
                                                                                Chairman, Textile Machinery Manufacturers'
                                                                                Association
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>Greetings of the day....</p>
                                                                    <p>
                                                                        On behalf of Institute of Fashion Technology, IPS
                                                                        Academy, Indore I congratulate you on the grand
                                                                        success of the India ITME-2022 event. I am amazed by
                                                                        your efforts and hard work. I wish you success for
                                                                        your next endeavours.
                                                                    </p>
                                                                    <p>
                                                                        I also want to thank you for giving the opportunity
                                                                        to our students to visit the exhibition, they
                                                                        enjoyed &amp; learnt thoroughly. Special thanks for
                                                                        meeting our representative Ms Rupali Mishra in
                                                                        person and giving her enough time from your damn
                                                                        hectic schedule to discuss and guide us. Thank you
                                                                        very much from the bottom of my heart. I apologize
                                                                        for not joining you at ITME, I will try next time.
                                                                        Students are making the videos of this trip, I will
                                                                        whatsapp on Ms Dorothy's phone no.
                                                                    </p>
                                                                    <p>
                                                                        In Reading Dr. RA Lal, Chairman, NISTI- Sir it was
                                                                        you who made this possible for us to attend. You
                                                                        only introduced me to ITME &amp; Seema Madam. Many
                                                                        many thanks to you for giving us this precious
                                                                        exposure. I wish your blessings will always shower
                                                                        upon us like this.... Thank you once again.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Preity_Sarva.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Preity Sarva</h6>
                                                                            <p>
                                                                                Principal, Institute of Fashion Technology (IFT)
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>I have no words to thank you.</p>
                                                                    <p>
                                                                        On behalf of Stäubli Group &amp; Swiss Textile
                                                                        Machinery manufacturers association a big thankyou.
                                                                    </p>
                                                                    <p>
                                                                        You have extended support beyond expectations &amp;
                                                                        deserve great appreciation from all of us at
                                                                        Stäubli.
                                                                    </p>
                                                                    <p>
                                                                        I am very proud to have you at this important
                                                                        position for the Textile world. The world has
                                                                        witnessed this great support.
                                                                    </p>
                                                                    <p>
                                                                        My personal thanks to each &amp; every individual of
                                                                        your team for making this extremely difficult task
                                                                        to happen
                                                                    </p>
                                                                    <p>Machine is installed &amp; about to start.</p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Surjit_Singh.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Surjit Singh Mahajan</h6>
                                                                            <p>Director, Staubli India</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        India ITME is a big event for us exhibitors &amp;
                                                                        our customers.
                                                                    </p>
                                                                    <p>
                                                                        Your team and you have shown tremendous patience,
                                                                        courteousness &amp; transparency in dealing with two
                                                                        postponements, a change in venue, exhibitors in a
                                                                        rush &amp; few dazed visitors. Please accept our
                                                                        sincere gratitude. Well played.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Siddharth_Kinariwala.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Siddharth Kinariwala</h6>
                                                                            <p>Director, NP Kinariwala Pvt Ltd</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        We thank you very much for your whole heatedly
                                                                        support before &amp; during the exhibition, We once
                                                                        again like to congratulate to You &amp; your team
                                                                        for successfully handling the whole event to the
                                                                        True international level. We are very much satisfied
                                                                        with all the arrangements &amp; no of visitors which
                                                                        were truly professional.
                                                                    </p>
                                                                    <p>
                                                                        We will definitely like to join upcoming events
                                                                        arranged by you &amp; please do up update for the
                                                                        same.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Kashyap_Mehta.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Kashyap Mehta</h6>
                                                                            <p>Sharnam Tex India Pvt Ltd.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        Thank you very much for your mail and we agree with
                                                                        you that this time not only the exhibitors and
                                                                        visitors made the show but the venue was wonderful
                                                                        and probably the best we experienced for organising
                                                                        ITME in future.
                                                                    </p>
                                                                    <p>
                                                                        Inspite of heavy flow of visitors, the movement was
                                                                        very easy, no blockages of any of the pathways,
                                                                        hardly any traffic congestion on the roads and the
                                                                        facilities were wonderful.
                                                                    </p>
                                                                    <p>
                                                                        We suggest you continue to use the same venue for
                                                                        future events.
                                                                    </p>
                                                                    <p>
                                                                        We look forward to hearing from you the dates for
                                                                        the next event which we suggest should be held after
                                                                        six years now i.e. In December' 2028
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/M_S_Gaur.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>M. S. Gaur</h6>
                                                                            <p>Director</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        Thank you very much for your mail, and we would also
                                                                        like to Congratulate Team INDIA ITME, for
                                                                        organisizing the event with grand success which is
                                                                        result of your TEAM'S dedicated efforts through out
                                                                        the process of managing the event.
                                                                    </p>
                                                                    <p>
                                                                        We, from AEON and EMS would like to thank entire
                                                                        TEAM INDIA ITME for all arrangements done during the
                                                                        event, which has resulted in enormous response for
                                                                        our AEON and EMS product profile during the event.
                                                                    </p>
                                                                    <p>
                                                                        Understanding that this time INDIA ITME has not
                                                                        given any of the participant momento for
                                                                        participation, we would like to request you to
                                                                        kindly share us draft of MOMENTO OF PARTICIPATION,
                                                                        which we can print and make a frame for our office
                                                                        display.
                                                                    </p>
                                                                    <p>
                                                                        Hope to have your kind understanding on the matter.
                                                                    </p>
                                                                    <p>
                                                                        Looking forward to hear from on this, and
                                                                        participating in the next event.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Shriram_R_Atgur.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Shriram R Atgur</h6>
                                                                            <p>
                                                                                Head-Sustainability &amp; Product Stewardship,
                                                                                AEON COMMERCIAL INDIA PVT LTD
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        Dear Seema ji. Compliments &amp; Congratulations you
                                                                        for hosting a grand ITME Show on par with the best
                                                                        of International Exhibitions! The venue chosen
                                                                        proved to be an excellent choice in terms of
                                                                        infrastructure and facilities. Kudos to you and your
                                                                        entire team. You made us proud!
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Pradeep_Sinha.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Pradeep Sinha</h6>
                                                                            <p>Chief Executive Officer, Inditech</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        Congratulations for wonderful Exhibition Show at
                                                                        NOIDA EXPO.
                                                                    </p>
                                                                    <p>
                                                                        We never expected such good exhibition with superb
                                                                        customer flow. I have been participated in india
                                                                        itme since 1996 this is the first time we got over
                                                                        whelming response. This time i must appreciated for
                                                                        cleanliness. Well organised show your hard works
                                                                        paid up like anything
                                                                    </p>
                                                                    <p>
                                                                        All. Credit goes to seema and her team (india itme
                                                                        team). Once again congratulations for best ever
                                                                        india itme.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Chandresh_Shah.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Chandresh Shah</h6>
                                                                            <p>
                                                                                Managing Director, Krsna Group &amp; Member
                                                                                ITAMMA
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="swiper-slide">
                                                        <div className="testimonial__item">
                                                            <div className="card testimonal_card">
                                                                <div className="card-body">
                                                                    <h6>
                                                                        <i className="fa fa-quote-left" />
                                                                    </h6>
                                                                    <p>
                                                                        Heartiest congratulations Seema ji to you and the
                                                                        ITME team for successfully organising ITME 2022 at
                                                                        entirely a new venue. Words will be less to
                                                                        appreciate what has been accomplished by you and
                                                                        your team. Everything was simply perfectly in
                                                                        order..the venue, infrastructure, events
                                                                        organisation, staying and transport arrangements.
                                                                        Full marks to you, Mr Hari Shankar, Ketan ji and
                                                                        your team. Please convey my feelings to Hari Shankar
                                                                        ji and Ketan ji as well and your staff.
                                                                    </p>
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="d-flex">
                                                                        <img
                                                                            src="assets/img/Testimonial_img/Gurudas_Aras.jpg"
                                                                            alt="person img"
                                                                            loading="lazy"
                                                                        />
                                                                        <div className="testi_name">
                                                                            <h6>Mr. Gurudas Aras</h6>
                                                                            <p>Strategic Consultant</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section
                                        className="invite_section project__area project__bg"
                                        data-aos="fade-up"
                                        data-aos-delay={300}
                                    >
                                        <div className="">
                                            <div className="row align-items-center">
                                                <div className="col-xl-12 col-lg-12 col-md-12">
                                                    <div className="Invite_main_div">
                                                        <h2 className="title">India ITME NXT Exhibition Invite</h2>
                                                        <p className="subTitle_txt">
                                                            Join us to showcase your innovations &amp; connect with
                                                            industry leaders
                                                        </p>
                                                        <div className="d-flex align-items-center">
                                                            <div className="date_section">
                                                                <h6>
                                                                    04<sup>th</sup> - 09<sup>th</sup> Dec 2026
                                                                </h6>
                                                                <p>@ Greater Noida, Uttar Pradesh</p>
                                                            </div>
                                                            <a
                                                                href="javascript:void(0)"
                                                                className="btn btn-primary JoinNow_btn login_btn_click"
                                                            >
                                                                JOIN NOW
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <section class="download_app_section" data-aos="fade-up" data-aos-delay="200">
      <div class="container">
          <div class="row">
              <div class="col-md-4 col-sm-7">
                  <div class="context">
                      <h6>Lets Connect</h6>
                      <h3>Get the <br/>FREE <span>Newsletter</span></h3>
                      <p>Subscribe to get the updates about new events</p>
                      <div class="subscribe_div">
                          <input type="text" class="form-control" placeholder="Your Email Address here" />
                          <a href="#" class="btn btn-primary">Subscribe Now</a>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-sm-5">
                  <div class="scanner_div">
                      <img src="assets/img/appqr.png" alt="appqr img" style="width: 130px;" loading="lazy" />
                      <p>Scan the QR Code to <br/>download the App</p>
                  </div>
              </div>
              <img src="assets/img/instagram-mocku1p.png" class="mobile_img" alt="instagram-mockup" loading="lazy" />
          </div>
      </div>
  </section> */}
                    <section
                        className="contact_details_section"
                        data-aos="fade-up"
                        data-aos-delay={200}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="contact_grid_section">
                                        <div className="d-flex">
                                            <i className="far fa-envelope" />
                                            <div className="content_div">
                                                <h6>Email Us</h6>
                                                <p>itme@india-itme.com</p>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <i className="fas fa-phone-alt" />
                                            <div className="content_div">
                                                <h6>Call Us</h6>
                                                <p>+91-9820 507 570</p>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <i className="far fa-clock" />
                                            <div className="content_div">
                                                <h6>Monday-Friday</h6>
                                                <p>10:30 am to 05:30 pm, IST (GMT +05.30)</p>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <i className="fas fa-map-marked" />
                                            <div className="content_div">
                                                <h6>Location</h6>
                                                <p>Nariman Point, Mumbai, INDIA</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(index1));